import React from 'react'
import PropTypes from 'prop-types'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

import './TextInput.scss'

class TextInput extends React.Component {
  _getContainerClasses = () => {
    const containerClasses = ['amd-text-input-container']
    if (!this.props.label) containerClasses.push('amd-text-input-container-no-label')
    return containerClasses
  }

  render() {
    const {
      dark,
      required,
      'aria-required': ariaRequired,
      'aria-invalid': ariaInvalid,
      'aria-describedby': ariaDescribedBy,
      id,
      autocomplete,
    } = this.props

    // Use provided id or fallback to name for accessibility
    const fieldId = id || this.props.name
    const containerClasses = this._getContainerClasses()

    // Determine if field is required either from explicit prop or aria-required
    const isRequired = required || ariaRequired

    return (
      <div className={containerClasses.join(' ')}>
        {this.props.prepend ? (
          <div className="input-group">
            <div className="input-group-prepend">
              <div className="input-group-text">{this.props.prepend}</div>
            </div>
            <div className="form-control input-group-control">
              <input
                className={`form-control${dark ? '-dark' : ''} amd-text-input-dark${
                  dark ? '-dark' : ''
                }`}
                type={this.props.type ? this.props.type : 'text'}
                id={fieldId}
                name={this.props.name}
                value={this.props.value}
                placeholder={this.props.placeholder}
                onChange={this.props.onChange}
                onBlur={this.props.onBlur}
                disabled={this.props.disabled ? 'true' : undefined}
                required={isRequired}
                aria-required={isRequired}
                aria-invalid={ariaInvalid}
                aria-describedby={ariaDescribedBy}
                autoComplete={autocomplete}
              />
              <label
                className={`amd-text-input-label${dark ? '-dark' : ''} ${
                  this.props.value ? 'amd-text-input-label-active' : ''
                }`}
                htmlFor={fieldId}
              >
                <FormattedMessage id={this.props.label} />
                {isRequired && (
                  <span className="required-indicator" aria-hidden="true">
                    *
                  </span>
                )}
                {isRequired && <span className="sr-only">(required)</span>}
              </label>
            </div>
          </div>
        ) : (
          <div>
            <input
              className={`form-control${dark ? '-dark' : ''} amd-text-input${dark ? '-dark' : ''}`}
              type={this.props.type ? this.props.type : 'text'}
              id={fieldId}
              name={this.props.name}
              ref={this.props.inputRef}
              value={this.props.value}
              placeholder={this.props.placeholder}
              onChange={this.props.onChange}
              onBlur={this.props.onBlur}
              disabled={this.props.disabled ? 'true' : undefined}
              required={isRequired}
              aria-required={isRequired}
              aria-invalid={ariaInvalid}
              aria-describedby={ariaDescribedBy}
              autoComplete={autocomplete}
            />
            <label
              className={`amd-text-input-label${dark ? '-dark' : ''} ${
                this.props.value ? 'amd-text-input-label-active' : ''
              }`}
              htmlFor={fieldId}
            >
              <FormattedMessage id={this.props.label} />
              {isRequired && (
                <span className="required-indicator" aria-hidden="true">
                  *
                </span>
              )}
              {isRequired && <span className="sr-only">(required)</span>}
            </label>
          </div>
        )}
      </div>
    )
  }
}

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  prepend: PropTypes.string,
  disabled: PropTypes.bool,
  dark: PropTypes.bool,
  // Accessibility props
  id: PropTypes.string,
  required: PropTypes.bool,
  'aria-required': PropTypes.bool,
  'aria-invalid': PropTypes.bool,
  'aria-describedby': PropTypes.string,
  autocomplete: PropTypes.string,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
}

export default TextInput
